export const initHeroCarousel = () => {
  console.log('initHeroCarousel');
  if (!document.querySelector('.swiper')) return;
  console.log('Starting swiper');
  const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    pagination: {
      currentClass: 'current-slide',
      el: '.word-counter',
      totalClass: 'total-amount',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.hero-next-slide',
      prevEl: '.hero-prev-slide',
    },
    on: {
      slideChange: function() {
        const captions = document.querySelectorAll('.captions > ul > li');
        captions.forEach((el, index) => {
          el.classList.toggle('active', index === this.realIndex);
        })
      },
    }
  });
};



// WEBPACK FOOTER //
// ./src/templates/components/newdev-hero/newdev-hero.js